import { render, staticRenderFns } from "./sign-auth.vue?vue&type=template&id=3783de4a&scoped=true&"
import script from "./sign-auth.vue?vue&type=script&lang=js&"
export * from "./sign-auth.vue?vue&type=script&lang=js&"
import style0 from "./sign-auth.vue?vue&type=style&index=0&id=3783de4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783de4a",
  null
  
)

export default component.exports